module.exports = __webpack_public_path__ + "img/parteight_pic.a74aaa75.png";